import type {Customer} from "@/components/customers/scripts/types";
import {createEmptyCustomer} from "@/components/customers/scripts/customerActions";

const selectCustomer = (customers: Customer[], customerId: number) => {
    let selectedCustomer: Customer | undefined;

    if(customerId && customers.length > 0){
      selectedCustomer = customers.find(e => e.id === customerId) as Customer;
    }

    if(!selectedCustomer){
        selectedCustomer = customers.length > 0 ? customers[0] : createEmptyCustomer();
    }

    return selectedCustomer;
};

export {
   selectCustomer
}
